import { SET_DELIVERY_ADDRESS } from './deliveryActionTypes'

export const setDeliveryAddress = (address: google.maps.places.PlaceResult | undefined ) => ({
  type: SET_DELIVERY_ADDRESS,
  payload: address,
});

export type SetDeliveryAddressAction = ReturnType<typeof setDeliveryAddress>;